import React, { useState } from "react";
import "./DeployChoose.css";
import img1 from '../deployassets/deploychoose1.png';
import img2 from '../deployassets/deploychoose2.png';
import img3 from '../deployassets/deploychoose3.png';
import img4 from '../deployassets/deploychoose4.png';

export default function DeployChoose() {
  const cards = [
    { img: img1, title: "Ownership", desc: "The digital collectibles issued on any NFT Marketplace are unique and they can't be replicated or reproduced. There is just one single owner per NFT." },
    { img: img2, title: "Authenticity & Transparency", desc: "Each non-fungible token comes with a unique product identity since these are developed on the Blockchain network." },
    { img: img3, title: "Portability", desc: "NFTs can be stored and transferred between users easily and quickly." },
    { img: img4, title: "Security", desc: "As NFTs get stored on the decentralized Blockchain network, they are secure and difficult to forge." }
  ];

  const isMobile = window.innerWidth <= 576;
  const visibleCards = isMobile ? 1 : 2;
  const maxIndex = cards.length - visibleCards;

  const [currentIndex, setCurrentIndex] = useState(0);

  const goToSlide = (index) => {
    if (index > maxIndex) {
      setCurrentIndex(0);
    } else if (index < 0) {
      setCurrentIndex(maxIndex);
    } else {
      setCurrentIndex(index);
    }
  };

  return (
    <div id="deploy-choose" className="marketmainclass">
<h2 className="heading"> Craft Unique Digital Assets with Non-Fungible Token Development </h2> <p className="subheading"> Tap into Rapidly Expanding Market, Innovate Your Offerings, and Establish a Stronger Connection with Your Audience </p>
      <div className="cards">
        {cards.map((card, i) => (
          <div className="card" key={i}>
            <img src={card.img} alt="" />
            <h3>{card.title}</h3>
            <p>{card.desc}</p>
          </div>
        ))}
      </div>

     <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{
              transform: `translateX(-${currentIndex * (isMobile ? 100 : 50)}%)`
            }}
          >
            {cards.map((card, index) => (
              <div className="carousel-card" key={index}>
                <img src={card.img} alt="" />
                <h3>{card.title}</h3>
                <p>{card.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* DOTS */}
        <div className="carousel-nav dots">
          {Array.from({ length: maxIndex + 1 }).map((_, index) => (
            <span
              key={index}
              className={`dot ${currentIndex === index ? "active" : ""}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>

      </div>
    </div>
  );
}
